import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { Chip, ChipProps, useTheme } from '@mui/material';
import { ChipTypeMap } from '@mui/material/Chip/Chip';
import React, { ReactElement } from 'react';

function SuccessChip<C extends React.ElementType = ChipTypeMap['defaultComponent']>(
  props: ChipProps<C, { component?: C }>,
): ReactElement {
  const { palette } = useTheme();

  return (
    <Chip
      color="success"
      variant="transparent"
      icon={<CheckCircleRoundedIcon style={{ fill: palette.success.main }} />}
      {...props}
    />
  );
}

export { SuccessChip };
